// extracted by mini-css-extract-plugin
export default {"base":"CardContent_base__PZSfA","title":"CardContent_title__0ARZ7","description":"CardContent_description__OkiWw"};